import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2 65Q2 15 46.5 7.6",
  fill: "none",
  "stroke-width": "6",
  "stroke-miterlimit": "10",
  "pointer-events": "stroke"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M55.4 6.1 44.5 14l2-6.4-4-5.4Z",
  "stroke-width": "6",
  "stroke-miterlimit": "10",
  "pointer-events": "all"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    style: _normalizeStyle(_ctx.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -4 63 70"
  }, _hoisted_3, 4))
}